<div class="relative w-full" data-testid="multi-select">
  <button
    type="button"
    class="flex w-full min-h-11 cursor-pointer items-center justify-between rounded-xl bg-lGray700 px-4 py-3 text-lWhite transition-all duration-200 hover:opacity-90"
    [class.opacity-50]="disabled"
    [class.cursor-not-allowed]="disabled"
    (click)="togglePanel()"
    (keydown.enter)="togglePanel()"
    (keydown.space)="togglePanel(); $event.preventDefault()"
    data-testid="multi-select-trigger"
  >
    <span class="flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-sm" data-testid="multi-select-label">{{ getDisplayLabel() }}</span>
    
    <div class="flex items-center gap-1 text-lWhite">
      @if (showClear && selectedItems.length > 0) {
        <l-icon 
          class="cursor-pointer text-xl transition-opacity duration-200 hover:opacity-70" 
          (click)="clear(); $event.stopPropagation()"
          (keydown.enter)="clear(); $event.stopPropagation()"
          (keydown.space)="clear(); $event.stopPropagation(); $event.preventDefault()"
          tabindex="0"
          role="button"
          data-testid="multi-select-clear"
        >close</l-icon>
      }
      <l-icon class="text-2xl transition-transform duration-300" [class.rotate-180]="isOpen">keyboard_arrow_down</l-icon>
    </div>
  </button>

  @if (isOpen) {
    <div class="relative z-[1000] mt-2 flex max-h-[300px] flex-col overflow-hidden rounded-2xl bg-lGray700 p-2 shadow-lg" data-testid="multi-select-panel">
      <div class="flex max-h-[240px] flex-col gap-1 overflow-y-auto pr-1">
        <button
          type="button"
          class="w-full cursor-pointer rounded-xl bg-lGray700 px-4 py-3 text-left text-sm text-lWhite transition-colors duration-200 hover:bg-lGray50/10"
          [class.bg-lGray900]="isAllSelected()"
          (click)="toggleAll()"
          (keydown.enter)="toggleAll()"
          (keydown.space)="toggleAll(); $event.preventDefault()"
          data-testid="multi-select-option-all"
        >
          <span>{{ allOptionLabel }}</span>
        </button>

        @for (option of options; track option) {
          <button
            type="button"
            class="w-full cursor-pointer rounded-xl bg-lGray700 px-4 py-3 text-left text-sm text-lWhite transition-colors duration-200 hover:bg-lGray50/10"
            [class.bg-lGray900]="isSelected(option)"
            (click)="toggleOption(option)"
            (keydown.enter)="toggleOption(option)"
            (keydown.space)="toggleOption(option); $event.preventDefault()"
            data-testid="multi-select-option"
          >
            <span>{{ getOptionLabel(option) }}</span>
          </button>
        }

        @if (options.length === 0) {
          <div class="p-4 text-center text-sm text-lWhite/50">Nenhum item encontrado</div>
        }
      </div>
    </div>
  }
</div>
